module.exports = __webpack_public_path__ + "static/img/8areaA_10.2575e7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/8areaA_10.png
// module id = 1055
// module chunks = 1